import React from 'react';

const ROWS = 8;

/**
 * Mobile loading state of the gradebook: student rows (avatar, name and grade) instead of the desktop grid
 * image, which is much wider than the screen.
 */
const GradebookMobilePlaceholder = () => (
  <div className="gradebook-mobile-placeholder" aria-busy="true">
    {Array.from({ length: ROWS }, (_, index) => (
      <div key={index} className="gradebook-mobile-placeholder-row">
        <span className="gradebook-mobile-placeholder-avatar" />
        <span className="gradebook-mobile-placeholder-name" />
        <span className="gradebook-mobile-placeholder-chip" />
      </div>
    ))}
  </div>
);

export default GradebookMobilePlaceholder;
